// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { BiwaveClient } from '@biwave/core';

export function installWindowErrorHandler(client: BiwaveClient): () => void {
  const handler = (event: ErrorEvent) => {
    // event.error is null for cross-origin "Script error." and resource-load
    // failures (failed <img>/<script> tags also dispatch 'error') — nothing
    // useful to capture in either case.
    if (!event.error) return;

    client.captureException(event.error, 'fatal', undefined, {
      type: 'onerror',
      handled: false,
    });
  };

  window.addEventListener('error', handler);

  return () => {
    window.removeEventListener('error', handler);
  };
}
